import config from '../config';
import { getCookie } from './cookies';
import { authHeader, handleResponse } from './helper';

const savePrescription = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiClinicalUrl}/deferredExam/save`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const getLatestPrescription = async (medicalConsultationDetailId) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/deferredExam/latest/${medicalConsultationDetailId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const listPrescriptions = async (medicalConsultationDetailId) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/deferredExam/list/${medicalConsultationDetailId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const cancelPrescription = async (prescriptionId) => {
  const requestOptions = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/deferredExam/cancel/${prescriptionId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const deferredExamService = {
  savePrescription,
  getLatestPrescription,
  listPrescriptions,
  cancelPrescription,
};
